import * as THREE from "three"
import noiseFragmentShader from "../shaders/console/noiseFragment.glsl"
import noiseVertexShader from "../shaders/console/noiseVertex.glsl"
import CustomShaderMaterial from "three-custom-shader-material/vanilla"

import Experience from "../Experience";

export default class Console {

    constructor() {

        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug
        this.time = this.experience.time
        this.consoleParts = []
        this.hitTargets = []
        this.buttonTexts = {}
        this.debugObject = {
            powerButtonColor: "#9afc6f",
            consoleColor: "#1f1c22",
            buttonColor: "#1f1c22"
        }


        // Setup
        this.resource = this.resources.items.console
        this.grillTexture = this.resources.items.grill
        this.grillTexture.wrapS = THREE.RepeatWrapping
        this.grillTexture.wrapT = THREE.RepeatWrapping
        this.grillTexture.repeat.set(30, 30)

        this.weirdTexture = this.resources.items.normal
        this.roughness = this.resources.items.roughness
        this.weirdTexture.wrapS = THREE.RepeatWrapping
        this.weirdTexture.wrapT = THREE.RepeatWrapping
        this.weirdTexture.repeat.set(10, 10)

        this.setModel()


        // Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.gui.addFolder("Console")
            this.model.traverse((child) => {
                if (child.name == "power") {
                    this.powerButton = child
                }
                else if (child.name == "console") {
                    this.consoleMaterial = child.material
                }
            })
            this.debugFolder.addColor(this.debugObject, "powerButtonColor").onChange((value) => {
                this.powerButton.material.color.set(value)
            })
            this.debugFolder.addColor(this.debugObject, "consoleColor").onChange((value) => {
                this.consoleMaterial.color.set(value)
            })
            this.debugFolder.addColor(this.debugObject, "buttonColor").name("Button Color").onChange((value) => {
                this.model.traverse((child) => {
                    if (child.name == "select" || child.name == "xyab" || child.name == "dpad") {
                        child.material.color.set(value)
                    }
                })
            })
            this.debugFolder.add(this.consoleMaterial.uniforms.uWhiteRoughness, "value", 0.0, 1.0, 0.001).name("White Roughness")
            this.debugFolder.add(this.consoleMaterial.uniforms.uBlackRoughness, "value", 0.0, 1.0, 0.001).name("Black Roughness")
            this.debugFolder.add(this.consoleMaterial.uniforms.uWhiteMetalness, "value", 0.0, 1.0, 0.001).name("White Metalness")
            this.debugFolder.add(this.consoleMaterial.uniforms.uBlackMetalness, "value", 0.0, 1.0, 0.001).name("Black Metalness")
        }
    }
    setModel() {
        this.model = this.resource.scene
        this.model.scale.set(0.1, 0.1, 0.1)
        this.model.rotation.y = Math.PI

        this.model.traverse((child) => {

            if (child.isMesh) {
                this.hitTargets.push(child)
                console.log(child.name)



                // Collect button text meshes (aText, xText, yText, bText)
                const textMatch = child.name.match(/^(a|b|x|y)Text$/)
                if (textMatch) {
                    this.buttonTexts[textMatch[1]] = child
                }

                if (child.name == "start" || child.name == "select" || child.name == "x" || child.name == "dpad" || child.name == "y" || child.name == "a" || child.name == "b") {

                    // if(child.name != "dpad")
                    this.consoleParts.push(child)

                    child.material = new THREE.MeshPhysicalMaterial({
                        color: this.debugObject.buttonColor,
                        roughness: 0.2,
                        metalness: 0.8
                    });
                }

                else if (child.name == "console") {
                    this.consoleMaterial = new CustomShaderMaterial({
                        baseMaterial: THREE.MeshPhysicalMaterial,



                        vertexShader: noiseVertexShader,
                        fragmentShader: noiseFragmentShader,
                        uniforms: {
                            uTime: { value: 0 },
                            uWhiteRoughness: { value: 0.439 },
                            uBlackRoughness: { value: 0.0 },
                            uWhiteMetalness: { value: 1.0 },
                            uBlackMetalness: { value: 1.0 },
                            uResolution: { value: new THREE.Vector2(this.experience.sizes.width, this.experience.sizes.height) }
                        },
                        normalMap: this.weirdTexture,
                        roughnessMap: this.roughness,
                        color: new THREE.Color("#1f1c22"),
                        // color: new THREE.Color("#252525"),
                        roughness: 0.7,
                        metalness: 0.5
                    });
                    child.material = this.consoleMaterial
                }

                else if (child.name == "screen") {
                    this.screenMesh = child
                    child.material = new THREE.MeshPhysicalMaterial({
                        color: 0x000000, // Make it black to serve as background
                        roughness: 0.0,
                        metalness: 0.7
                    });
                }

                else if (child.name == "power") {
                    child.material = new THREE.MeshPhysicalMaterial({
                        color: new THREE.Color("#521094"),
                        roughness: 1.0,
                        metalness: 1.0
                    });
                }
                else if (child.name == "grills") {
                    child.material = new THREE.MeshPhysicalMaterial({
                        normalMap: this.grillTexture,
                        color: new THREE.Color("#000000")
                    });
                }

            }
        });
        console.log("Console buttonTexts mapping:", this.buttonTexts)
        this.model.position.set(0, 0.3, 0)
        this.scene.add(this.model)


    }

    update() {
        if (this.consoleMaterial) {
            this.consoleMaterial.uniforms.uTime.value = this.time.elapsedTime
            this.consoleMaterial.uniforms.uResolution.value = new THREE.Vector2(this.experience.sizes.width, this.experience.sizes.height)
        }
    }
}
